import {
  HttpClient, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor,
  HttpRequest
} from '@angular/common/http';

import { Injectable } from '@angular/core';
import {Observable} from "rxjs/Observable";
import {StorageServiceProvider} from "../storage-service/storage-service";

/*
  Generated class for the HttpInterceptorProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class HttpInterceptorProvider implements HttpInterceptor{

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token = this.storageService.getStorage('JWTToken');
    const customReq = req.clone({headers: req.headers.set('Authorization', 'Bearer ' + token)});
    return next.handle(customReq);
  }

  constructor(public storageService: StorageServiceProvider) {
  }

}



// WEBPACK FOOTER //
// ./src/providers/http-interceptor/http-interceptor.ts